import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { SwitchInput } from '../../SwitchInput';
import { getTranslation } from '../../../utils/translations';

import { liveSelector } from 'store/modules/competition-nav/selectors';
import { setLive } from 'common/store/modules/competition-nav/init';
import { useGetLiveLadderQuery } from 'store/modules/api/cfs-api';

export const LiveToggleNavItem = ({
    roundId,
    className,
    labelRightPosition
}) => {
    const dispatch = useDispatch();

    const live = useSelector(liveSelector);

    const { data: liveLadderData = [] } = useGetLiveLadderQuery({
        roundId: roundId
    });

    const showLiveToggle =
        liveLadderData?.liveLadderPositions?.find((item) => item?.playing) ||
        false;

    if (!showLiveToggle) {
        return <></>;
    }

    return (
        <div className={`competition-nav__live-toggle ${className}`}>
            <SwitchInput
                labelRightPosition={labelRightPosition}
                id="ladder-live-toggle"
                label={getTranslation('label.ladder.live')}
                isChecked={live.isActive}
                onChange={(isActive) => dispatch(setLive({ isActive }))}
            />
        </div>
    );
};

LiveToggleNavItem.propTypes = {
    roundId: PropTypes.string,
    className: PropTypes.string,
    labelRightPosition: PropTypes.bool
};
